import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const MARKETPLACE = () => { return URI(`${API_BASE}/api/v2/marketplace/requests/`) }
